import { Name } from './columns/name';
import { DateObserved } from './columns/date-observed';
import { Paginator, SortDirection } from '@app/classes';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { WorkSchedule } from '@models/time-off-v3/works-schedule.model';
import { TimeOffDay } from '@models/time-off-v3/time-off-day.model';
import { numericRange } from '@app/functions/numeric-range';
import { Table } from '@app/modules/table/classes/table.class';
import { YearSelectFilter } from '@app/modules/table/classes/table-filters/year-select-filter.class';

const editOption: MenuColumnItem = {
    label: 'time-off-v3.editHoliday',
    event: 'edit',
};

const deleteOption: MenuColumnItem = {
    label: 'time-off-v3.deleteHolidayTitle',
    event: 'delete',
};

export class HolidaysTable extends Table {
    sortDirection = SortDirection.ASC;
    showMenuColumnOptions = true;
    activeYear: number;
    protected defaultSortProperty = 'date';
    private yearSelectFilter: YearSelectFilter;

    constructor(private workSchedule: WorkSchedule) {
        super();

        this.yearSelectFilter = new YearSelectFilter('date', HolidaysTable.getYearsRangeOptions(), {
            initialSelection: {
                label: HolidaysTable.getCurrentYear().toString(),
                value: HolidaysTable.getCurrentYear(),
            },
            nullable: false,
        });

        this.yearSelectFilter.onChanges.subscribe((values) => {
            this.activeYear = new Date(values[0].value.toString().replaceAll('-', '/')).getFullYear();
        });

        this.filters = [this.yearSelectFilter];

        this.boot();
    }

    static getYearsRangeOptions(): { label: string; value: number }[] {
        const year = this.getCurrentYear();
        const yearsRange = 10;

        return numericRange(yearsRange)
            .map((offset: number) => year + offset)
            .map((year) => {
                return { label: year.toString(), value: year };
            });
    }

    static getCurrentYear(): number {
        return new Date().getFullYear();
    }

    get year(): number {
        return this.activeYear;
    }

    goToYear(year: number): void {
        this.yearSelectFilter.selectYear(year);
    }

    setColumns(): void {
        const dateObservedColumn = new DateObserved();

        this.sortColumn = dateObservedColumn;
        this.columns = [new Name(), dateObservedColumn];
    }

    setDataSource(): void {
        this.paginator = new Paginator(TimeOffDay.where('workScheduleId', this.workSchedule.id).limit(0));
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        return [editOption, deleteOption];
    }
}
